import { createContext } from 'react';
import { IMiniInterviewProps } from 'src/packages/polaris/types/interviews';

export const PolarisContext = createContext(false);

export function withPolarisContext<P extends IMiniInterviewProps>(
  Component: React.FunctionComponent<IMiniInterviewProps>,
) {
  return function WithPolarisContext(props: P) {
    return (
      <PolarisContext.Provider value={props.polarisProps?.displayPolarisUI as any}>
        <Component {...props} />
      </PolarisContext.Provider>
    );
  };
}
